import { render, staticRenderFns } from "./KOLPayoutBatchDetail.vue?vue&type=template&id=3297af06&"
import script from "./KOLPayoutBatchDetail.vue?vue&type=script&lang=js&"
export * from "./KOLPayoutBatchDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports